import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  const navigationLinks = [{
    path: '/',
    label: 'Home'
  }, {
    path: '/about',
    label: 'About Us'
  }, {
    path: '/programs',
    label: 'Programs'
  }, {
    path: '/team',
    label: 'Meet the Board'
  }, {
    path: '/training-center',
    label: 'Training Center'
  }, {
    path: '/roadmap',
    label: 'Roadmap'
  }, {
    path: '/support',
    label: 'Support'
  }, {
    path: '/contact',
    label: 'Contact Us'
  }];
  return <footer className="bg-white py-12 border-t border-gray-200" data-id="element-97">
      <div className="max-w-7xl mx-auto px-4" data-id="element-98">
        <div className="flex flex-col items-center gap-8" data-id="element-99">
          <Link to="/" className="transform transition-transform hover:-translate-y-1" data-id="element-100">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5PpnjrAjEGa7tmavMcMWw6/ictclogo.png" alt="Israeli Civilian Training Foundation Logo" className="h-14" data-id="element-101" />
          </Link>
          <nav className="w-full max-w-xl" data-id="element-102">
            <ul className="flex flex-wrap justify-center gap-y-4 gap-x-6" data-id="element-103">
              {navigationLinks.map(link => <li key={link.path} data-id="element-104">
                  <Link to={link.path} className="text-gray-600 hover:text-israel-blue transition-all transform hover:-translate-y-1 font-light tracking-normal" data-id="element-105">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
          <div className="text-center" data-id="element-106">
            <p className="text-gray-600 font-light" data-id="element-107">
              &copy; {new Date().getFullYear()} Israeli Civilian Training
              Foundation. All rights reserved. |{' '}
              <Link to="/privacy" className="hover:text-israel-blue" data-id="element-108">
                Privacy
              </Link>{' '}
              |{' '}
              <Link to="/terms" className="hover:text-israel-blue" data-id="element-109">
                Terms
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;